<template>
  <AdminDashboard v-if="user.role_id === 1" type="life" />
  <Dashboard v-else-if="user.role_id === 2" type="life" />
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Dashboard from "@/components/dashboards/Dashboard";
import AdminDashboard from "@/components/dashboards/AdminDashboard";

export default {
  name: "Life",
  components: {
    Dashboard,
    AdminDashboard,
  },
  methods: {
    ...mapMutations({
      SET_TYPE_FILTER: "filters/SET_TYPE_FILTER",
    }),
  },
  created() {
    this.SET_TYPE_FILTER(2);
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
};
</script>